import type { FC } from 'react';

import { L12nText } from '../../text/L12nText';

import styles from './MessageInput.module.css';

interface SupportingTextProps {
  cashierCallback?: () => void;
}

export const SupportingText: FC<SupportingTextProps> = ({ cashierCallback }) => {
  return (
    <span className={styles.messageInput__supportingText}>
      <L12nText tk="BALANCETOCHAT" />
      {cashierCallback && (
        <div className={styles.messageInput__buttonLink} onClick={cashierCallback}>
          <L12nText tk="GO_TO_CASHIER" />
        </div>
      )}
    </span>
  );
};
